import { useEffect, useState } from 'react';
import './App.css';
import { auth } from './firebase';
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';
import PlaceLibrary from './components/PlaceLibrary';
import Sidebar from './components/Sidebar';
import Prospects from './components/Prospects';
import Clients from './components/Clients';

function App() {
  const [user, setUser] = useState(null);
  const [authStatus, setAuthStatus] = useState('loading');
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [currentPage, setCurrentPage] = useState('leaderboard');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {
        setUser(currentUser);
        setAuthStatus(currentUser ? 'success' : 'idle');
      },
      (authError) => {
        setError(authError.message);
        setAuthStatus('error');
      },
    );

    return unsubscribe;
  }, []);

  const handleEmailSignIn = async (event) => {
    event?.preventDefault();
    if (!email || !password) {
      setError('Enter both email and password before signing in.');
      return;
    }

    setError(null);
    setAuthStatus('loading');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (signInError) {
      setError(signInError.message);
      setAuthStatus('error');
    }
  };

  const handleSignOut = async () => {
    setError(null);
    setAuthStatus('loading');
    try {
      await signOut(auth);
      setAuthStatus('idle');
    } catch (signOutError) {
      setError(signOutError.message);
      setAuthStatus('error');
    }
  };

  if (authStatus === 'loading') {
    return (
      <div className="App">
        <div className="loading-screen">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="App">
        <div className="login-container">
          <h1>Local Business Data Collection</h1>
          <section className="card">
            <h2>Sign In</h2>
              <form className="auth-form" onSubmit={handleEmailSignIn}>
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="you@example.com"
                />

                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  placeholder="Password"
                />

                <button type="submit">Sign In with Email</button>
              </form>

            </section>

            {error && (
              <div className="error" role="alert">
                <strong>Error:</strong> {error}
              </div>
            )}
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <>
          <div className="top-bar">
            <h1>Local Business Data Collection</h1>
            <div className="user-info">
              <span>Signed in as <code>{user.email}</code></span>
              <button type="button" onClick={handleSignOut} className="sign-out-btn">
                Sign Out
              </button>
            </div>
          </div>

          <div className="main-layout">
            <Sidebar currentPage={currentPage} onPageChange={setCurrentPage} />
            <main className="content-area">
              {currentPage === 'leaderboard' && <PlaceLibrary user={user} />}
              {currentPage === 'prospects' && <Prospects user={user} />}
              {currentPage === 'clients' && <Clients user={user} />}

              {error && (
                <div className="error" role="alert">
                  <strong>Error:</strong> {error}
                </div>
              )}
            </main>
          </div>
        </>
      </header>
    </div>
  );
}

export default App;
